/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Living_RoomInputs */

const en_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Living Room`)
};

const es_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sala de estar`)
};

const fr_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salon`)
};

const de_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wohnzimmer`)
};

const ja_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リビングルーム`)
};

const zh_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客厅`)
};

const ar_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غرفة المعيشة`)
};

const id_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang Tamu`)
};

const it_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soggiorno`)
};

const ru_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гостиная`)
};

const pt_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sala de Estar`)
};

const ko_val_living_room = /** @type {(inputs: Val_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`거실`)
};

/**
* | output |
* | --- |
* | "Living Room" |
*
* @param {Val_Living_RoomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_living_room = /** @type {((inputs?: Val_Living_RoomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Living_RoomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_living_room(inputs)
	if (locale === "es") return es_val_living_room(inputs)
	if (locale === "fr") return fr_val_living_room(inputs)
	if (locale === "de") return de_val_living_room(inputs)
	if (locale === "ja") return ja_val_living_room(inputs)
	if (locale === "zh") return zh_val_living_room(inputs)
	if (locale === "ar") return ar_val_living_room(inputs)
	if (locale === "id") return id_val_living_room(inputs)
	if (locale === "it") return it_val_living_room(inputs)
	if (locale === "ru") return ru_val_living_room(inputs)
	if (locale === "pt") return pt_val_living_room(inputs)
	return ko_val_living_room(inputs)
});